import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

new Accordion('#faq-accordion', {
  duration: 300,
  showMultiple: false,
  openOnInit: [],
});